/* AdventureBox · Calendrier · section Shopify « ab-calendrier » (porté du prototype final du 2026-09-29)
   Données : <script type="application/json" id="ab-events"> rendu par sections/ab-calendrier.liquid. ?today=AAAA-MM-JJ fige la date. */
/* AdventureBox · Calendrier · noyau sans DOM : dates, modèle, rendu HTML, JSON-LD, .ics.
   Le même code sert au pré-rendu (Node / Liquid de référence) et au navigateur. */
(function (G) {
  'use strict';

  var TZ = 'America/Toronto';
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var JOURS_C = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  var MOIS_C = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juill.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var JOUR_IDX = { dimanche: 0, lundi: 1, mardi: 2, mercredi: 3, jeudi: 4, vendredi: 5, samedi: 6 };
  var ICS_DAYS = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
  var HEAD_WINDOW_DAYS = 45; /* au-delà, le héros passe à la prochaine soirée et le gros événement va dans « Ensuite » */

  /* ---------- Dates (toujours à l'heure de Sherbrooke) ---------- */
  var DTF = new Intl.DateTimeFormat('en-CA', {
    timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  });
  function parts(date) {
    var o = {};
    DTF.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function keyOf(date) { var p = parts(date); return ymd(p.y, p.m, p.d); }
  function splitKey(k) { var a = k.split('-'); return { y: +a[0], m: +a[1], d: +a[2] }; }
  function keyUTC(k) { var s = splitKey(k); return Date.UTC(s.y, s.m - 1, s.d); }
  function addDays(k, n) {
    var t = new Date(keyUTC(k) + n * 864e5);
    return ymd(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
  }
  function dow(k) { return new Date(keyUTC(k)).getUTCDay(); }
  function diffDays(a, b) { return Math.round((keyUTC(b) - keyUTC(a)) / 864e5); }
  function lastOfMonth(y, m) { return addDays(m === 12 ? ymd(y + 1, 1, 1) : ymd(y, m + 1, 1), -1); }
  /* Heure murale à Sherbrooke -> instant absolu (gère l'heure avancée) */
  function zoned(k, h, mi) {
    var s = splitKey(k);
    var want = Date.UTC(s.y, s.m - 1, s.d, h, mi || 0);
    var t = want;
    for (var i = 0; i < 3; i++) {
      var p = parts(new Date(t));
      var diff = want - Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi);
      if (!diff) break;
      t += diff;
    }
    return new Date(t);
  }
  function isoLocal(date) {
    var p = parts(date);
    var base = date.getTime() - (date.getTime() % 1000);
    var off = Math.round((Date.UTC(p.y, p.m - 1, p.d, p.h, p.mi, p.s) - base) / 60000);
    var a = Math.abs(off);
    return ymd(p.y, p.m, p.d) + 'T' + pad(p.h) + ':' + pad(p.mi) + ':00' + (off < 0 ? '-' : '+') + pad(Math.floor(a / 60)) + ':' + pad(a % 60);
  }
  function lastWeekdayOnOrBefore(k, wd) { while (dow(k) !== wd) k = addDays(k, -1); return k; }
  function firstWeekdayOnOrAfter(k, wd) { while (dow(k) !== wd) k = addDays(k, 1); return k; }

  /* ---------- Formats québécois ---------- */
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function heure(date) { var p = parts(date); return p.h + 'h' + (p.mi ? pad(p.mi) : ''); }
  function num(d) { return d + (d === 1 ? 'er' : ''); }
  function jourLong(k) { var s = splitKey(k); return JOURS[dow(k)] + ' ' + num(s.d) + ' ' + MOIS[s.m - 1]; }
  /* Jour en toutes lettres partout (« Jeu. » se lirait « jeu ») ; seule la bande de dates abrège */
  function jourCourt(k) { var s = splitKey(k); return JOURS[dow(k)] + ' ' + num(s.d) + ' ' + MOIS_C[s.m - 1]; }
  function jourNum(k) { return JOURS[dow(k)] + ' ' + num(splitKey(k).d); }
  function moisLabel(y, m) { return cap(MOIS[m - 1]) + ' ' + y; }
  function prix(n) {
    var v = Number(n);
    var s = (Math.round(v * 100) % 100) ? v.toFixed(2).replace('.', ',') : String(Math.round(v));
    return s + '\u00a0$';
  }
  function rel(k, today) {
    var d = diffDays(today, k);
    return d < 0 ? '' : d === 0 ? 'Ce soir' : d === 1 ? 'Demain' : 'Dans ' + d + ' jours';
  }
  function plural(n, s, p) { return n + ' ' + (n > 1 ? (p || s + 's') : s); }
  function joinEt(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' et ' + a[a.length - 1]; }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Titre affiché : le point médian ne commence jamais une ligne */
  function nb(t) { return String(t || '').replace(/ \u00b7 /g, '\u00a0\u00b7 '); }
  /* Lien d'inscription : seulement un lien EXACT. Une page d'accueil (https://melee.gg/) ne mène à aucun événement. */
  function eventUrl(u) {
    u = String(u || '').trim();
    if (!/^https:\/\/[^\s/?#]+\.[^\s/?#]+\/[^\s]*[^\s/]/i.test(u)) return '';
    return u;
  }
  function telHref(t) { var d = String(t || '').replace(/\D/g, ''); return 'tel:+' + (d.length === 10 ? '1' + d : d); }
  function mapsHref(b) { return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent((b.nom || 'AdventureBox') + ' ' + String(b.adresse || '').replace(/,\s*QC.*$/, '')); }
  function shortAddr(b) { return String(b.adresse || '').replace(/,\s*QC.*$/, ''); }

  /* ---------- Couleurs par jeu : petites touches sur fond crème, contraste AA calculé ---------- */
  function hexRgb(h) {
    h = String(h || '#eda94a').replace('#', '');
    if (h.length === 3) h = h.replace(/./g, '$&$&');
    var n = parseInt(h, 16);
    return [n >> 16 & 255, n >> 8 & 255, n & 255];
  }
  function rgbHex(c) { return '#' + c.map(function (v) { v = Math.max(0, Math.min(255, Math.round(v))); return (v < 16 ? '0' : '') + v.toString(16); }).join(''); }
  function lum(c) {
    var a = c.map(function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  function contrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function mix(c, t, k) { return c.map(function (v, i) { return v + (t[i] - v) * k; }); }
  function safeOn(hex, bgHex, target) {
    var c = hexRgb(hex), bg = hexRgb(bgHex), to = lum(bg) > 0.5 ? [0, 0, 0] : [255, 255, 255], k = 0;
    while (contrast(c, bg) < target && k < 1) { k += 0.04; c = mix(hexRgb(hex), to, k); }
    return rgbHex(c);
  }
  /* c1 : pastilles, filets et bordures (au moins 3:1 sur le papier #f6ecd6) ;
     ct : petites étiquettes écrites en couleur (au moins 4,5:1 sur #f6ecd6, donc aussi sur #fbf3df, #fef6e8 et blanc) ;
     le jaune Cyberpunk devient un olive foncé lisible. cg, cb et cbt restent pour compatibilité (plus de dégradé ni de fond coloré). */
  var PAPER = '#f6ecd6', INK = '#1a1410';
  var palCache = {};
  function palette(cat, cats, override) {
    var ck = cat + '|' + (override || '');
    if (palCache[ck]) return palCache[ck];
    var cols = ((cats[cat] && cats[cat].couleurs) || ['#eda94a']).map(function (c) { return String(c).toLowerCase(); });
    var raw = String(override || cols[0]).toLowerCase();
    var c1 = safeOn(rgbHex(mix(hexRgb(raw), hexRgb(INK), 0.12)), PAPER, 3.2); /* assourdie de 12 % vers l'encre : touche de couleur, pas de fluo */
    var ct = safeOn(raw, PAPER, 4.7);
    var alt = uniq(cols).filter(function (c) { return c !== raw; })[0] || '#d18a2b';
    var c2 = safeOn(alt, PAPER, 3.2);
    return (palCache[ck] = { c1: c1, c2: c2, ct: ct, cg: c1, cb: c1, cbt: INK });
  }
  function styleVars(p) { return '--c1:' + p.c1 + ';--c2:' + p.c2 + ';--ct:' + p.ct + ';--cg:' + p.cg + ';--cb:' + p.cb + ';--cbt:' + p.cbt; }

  /* ---------- Modèle : événements datés + hebdos dépliés ---------- */
  function parseHeure(s) {
    var m = /^(\d{1,2})\s*h\s*(\d{2})?$/i.exec(String(s || '').trim());
    return m ? { h: +m[1], mi: +(m[2] || 0) } : null;
  }
  function inRange(k, w) { return (!w.actif_du || k >= w.actif_du) && (!w.actif_au || k <= w.actif_au); }
  /* Couleur d'accent : seulement un vrai code hex (l'ancien champ accent_color peut contenir autre chose) */
  function hexOk(c) { c = String(c || '').trim(); return /^#([0-9a-f]{3}){1,2}$/i.test(c) ? c : ''; }
  /* « groupe » peut être un identifiant (prerift-radiance) : on affiche alors le titre sans la session */
  function groupLabel(g, t) {
    g = String(g || '');
    if (!g) return '';
    if (/[\sA-ZÀ-ɏ]/.test(g)) return g;
    return String(t || '').split(' · ')[0] || g;
  }
  function imgFields(src) {
    return { image: src.image || '', imageMini: src.image_mini || '', imgW: +src.image_w || 0, imgH: +src.image_h || 0, focus: src.image_focus || '' };
  }
  function assign(o, x) { for (var k in x) o[k] = x[k]; return o; }

  function build(data, now, opts) {
    opts = opts || {};
    data = data || {};
    var cats = data.categories || {};
    var todayKey = keyOf(now);
    var t = splitKey(todayKey);
    var ahead = opts.monthsAhead == null ? 3 : opts.monthsAhead;
    var em = t.m + ahead, ey = t.y + Math.floor((em - 1) / 12);
    em = ((em - 1) % 12) + 1;
    var horizon = lastOfMonth(ey, em);

    function mk(o) {
      o.key = keyOf(o.start);
      o.pal = palette(o.cat, cats, o.couleur);
      o.catLabel = (cats[o.cat] && cats[o.cat].label) || o.jeu || '';
      return o;
    }

    var specials = (data.evenements || []).map(function (e, ei) {
      var s = new Date(e.debut);
      if (isNaN(s.getTime())) return null;
      return mk(assign({
        id: e.id, kind: 'special', ord: ei, titre: e.titre || '', jeu: e.jeu || '', cat: e.categorie, couleur: hexOk(e.couleur),
        start: s, end: e.duree_min ? new Date(s.getTime() + e.duree_min * 6e4) : null,
        prix: e.prix == null ? null : e.prix, places: e.places || null, format: e.format || '', details: e.details || [],
        url: eventUrl(e.inscription_url), urlLabel: e.inscription_label || '', mode: e.inscription_mode || '',
        code: String(e.code_inscription || '').trim(),
        groupe: e.groupe || '', gLabel: groupLabel(e.groupe, e.titre), session: e.session || '',
        accroche: e.accroche || '', head: e.tete_affiche !== false, holo: !!e.mise_en_avant, lieu: e.lieu || ''
      }, imgFields(e)));
    }).filter(Boolean);

    /* Un événement daté prime sur l'hebdo du même jeu le même soir */
    var busy = {};
    specials.forEach(function (o) { var b = o.key + '|' + o.cat; (busy[b] = busy[b] || []).push(o); });

    var weeklies = [], skipped = {}, weeklyDefs = {};
    (data.hebdos || []).forEach(function (w, wi) {
      var wd = JOUR_IDX[String(w.jour || '').toLowerCase()];
      var hm = parseHeure(w.heure);
      if (wd == null || !hm || !w.id) return;
      var sauf = {};
      (w.sauf || []).forEach(function (k) { sauf[k] = 1; });
      var def = { def: w, wd: wd, hm: hm, firstIn: null };
      weeklyDefs[w.id] = def;
      skipped[w.id] = [];
      for (var k = firstWeekdayOnOrAfter(todayKey, wd); k <= horizon; k = addDays(k, 7)) {
        if (!inRange(k, w)) continue;
        if (!def.firstIn) def.firstIn = k;
        if (sauf[k]) { skipped[w.id].push({ key: k, by: null }); continue; }
        var b = busy[k + '|' + w.categorie];
        if (b) { skipped[w.id].push({ key: k, by: b[0] }); continue; }
        weeklies.push(mk(assign({
          id: w.id + '-' + k, weeklyId: w.id, kind: 'weekly', ord: wi, titre: w.titre || '', jeu: w.jeu || '', cat: w.categorie, couleur: hexOk(w.couleur),
          start: zoned(k, hm.h, hm.mi), end: w.duree_min ? zoned(k, hm.h, hm.mi + w.duree_min) : null,
          prix: w.prix == null ? null : w.prix, places: w.places || null, format: w.format || '', details: w.details || [],
          url: eventUrl(w.inscription_url), urlLabel: w.inscription_label || '', mode: w.inscription_mode || '', code: '',
          jour: String(w.jour).toLowerCase(), head: false, holo: false, lieu: w.lieu || ''
        }, imgFields(w))));
      }
    });

    var all = specials.concat(weeklies).sort(function (a, b) {
      return (a.start - b.start) || ((a.kind === 'special') === (b.kind === 'special') ? 0 : a.kind === 'special' ? -1 : 1) || (a.ord - b.ord);
    });
    var nowT = now.getTime();
    var upcoming = all.filter(function (o) {
      var endT = o.end ? o.end.getTime() : o.start.getTime() + 3 * 36e5;
      return endT > nowT && o.key <= horizon;
    });
    var byId = {}, byKey = {};
    upcoming.forEach(function (o) { byId[o.id] = o; (byKey[o.key] = byKey[o.key] || []).push(o); });

    return {
      data: data, cats: cats, now: now, todayKey: todayKey, horizon: horizon,
      all: all, upcoming: upcoming, byId: byId, byKey: byKey, skipped: skipped, weeklyDefs: weeklyDefs
    };
  }

  /* Soirées d'un même événement (champ « groupe ») encore à venir */
  function groupOf(M, o) {
    if (!o.groupe) return [o];
    return M.upcoming.filter(function (x) { return x.kind === 'special' && x.groupe === o.groupe; });
  }
  /* Héros : tête d'affiche des 45 prochains jours, sinon la prochaine soirée. Jamais un événement passé. */
  function heroInfo(M) {
    var bigs = M.upcoming.filter(function (x) { return x.kind === 'special'; });
    var heads = bigs.filter(function (x) { return x.head; });
    if (!heads.length) heads = bigs;
    var first = heads[0];
    if (first && diffDays(M.todayKey, first.key) <= HEAD_WINDOW_DAYS) {
      var g = groupOf(M, first);
      var rest = heads.filter(function (x) { return g.indexOf(x) < 0; });
      return { mode: 'big', hero: first, group: g, next: rest[0] ? groupOf(M, rest[0]) : null };
    }
    var nx = M.upcoming[0];
    if (!nx) return { mode: 'none', hero: null, group: [], next: null };
    return { mode: 'night', hero: nx, group: [nx], night: M.byKey[nx.key], next: first ? groupOf(M, first) : null };
  }
  /* Mois de l'affiche : le mois courant, ou le suivant si sa grille commence déjà cette semaine */
  function posterMonth(M) {
    var t = splitKey(M.todayKey);
    var nm = t.m === 12 ? { y: t.y + 1, m: 1 } : { y: t.y, m: t.m + 1 };
    var first = ymd(nm.y, nm.m, 1);
    var gridStart = addDays(first, -((dow(first) + 6) % 7));
    return M.todayKey >= gridStart ? nm : { y: t.y, m: t.m };
  }

  /* ---------- Rendu HTML (partagé : pré-rendu serveur et JS) ---------- */
  function icon(n, cls) { return '<svg class="abcal-i' + (cls ? ' ' + cls : '') + '" aria-hidden="true" focusable="false"><use href="#abcal-i-' + n + '"></use></svg>'; }
  function tag(o) { return '<span class="abcal-tag"><span class="abcal-dot" aria-hidden="true"></span>' + esc(o.catLabel) + '</span>'; }
  function coin(p) { var s = prix(p); return '<span class="abcal-coin' + (s.length > 5 ? ' abcal-coin--long' : '') + '">' + esc(s) + '</span>'; }
  /* Images Shopify : 160, 400, 800 et 1200 px (paramètre width= du CDN). Mêmes attributs que le pré-rendu Liquid (cache du navigateur).
     variant « mini » : vignette de liste · « thumb » / « thumbWide » : vignette du héros (affiche / paysage) ·
     « poster » : affiche du héros (cachée sous 1024 px) · « next » : affiches du bloc « Ensuite » */
  var SIZES = {
    thumb: '(min-width:1024px) 1px, (min-width:768px) 128px, (max-width:374px) 64px, 72px',
    thumbWide: '(min-width:1024px) 1px, (min-width:768px) 200px, (max-width:374px) 96px, 112px',
    poster: '(min-width:1024px) 400px, 1px',
    next: '(min-width:1024px) 200px, 170px'
  };
  function sized(u, w) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : ''; }
  function srcset(o) {
    var m = o.imageMini, a = sized(o.image, 400), b = sized(o.image, 800);
    if (!m || !a || !b) return m ? esc(m) + ' 160w, ' + esc(o.image) + ' 1200w' : '';
    return esc(m) + ' 160w, ' + esc(a) + ' 400w, ' + esc(b) + ' 800w, ' + esc(o.image) + ' 1200w';
  }
  function img(o, cls, opt) {
    opt = opt || {};
    if (!o.image) return '';
    var v = opt.variant, mini = o.imageMini || o.image;
    var src = v === 'mini' || v === 'thumb' || v === 'thumbWide' ? mini : o.image;
    var ss = SIZES[v] ? srcset(o) : '';
    var set = ss ? ' srcset="' + ss + '" sizes="' + SIZES[v] + '"' : '';
    var dims = opt.dims && o.imgW && o.imgH ? ' width="' + o.imgW + '" height="' + o.imgH + '"' : '';
    return '<img class="' + cls + '" src="' + esc(src) + '"' + set + dims + ' alt="' + esc(opt.alt || '') + '"' +
      (opt.focus !== false && o.focus ? ' style="object-position:' + esc(o.focus) + '"' : '') +
      (opt.eager ? ' fetchpriority="high"' : ' loading="lazy"') + ' decoding="async">';
  }
  function isWide(o) { return !!(o.imgW && o.imgH && o.imgW > o.imgH * 1.2); }
  function anchor(o) { return 'abcal-e-' + o.id; }
  function neonTitle(t, o) {
    t = nb(t);
    var w = o.catLabel || '', i = w ? t.toLowerCase().indexOf(w.toLowerCase()) : -1;
    var cls = 'abcal-neon' + (o.holo ? ' abcal-holo' : '');
    if (i < 0) return '<span class="' + cls + '">' + esc(t) + '</span>';
    return esc(t.slice(0, i)) + '<span class="' + cls + '">' + esc(t.slice(i, i + w.length)) + '</span>' + esc(t.slice(i + w.length));
  }
  function whereLabel(o) { var m = /(sur .+)$/i.exec(o.urlLabel || ''); return m ? m[1] : ''; }
  function stat(label, value) { return '<div class="abcal-stat"><dt>' + label + '</dt><dd>' + value + '</dd></div>'; }
  function stats(o) {
    var k = o.key;
    var date = '<span class="abcal-s-only">' + esc(cap(jourCourt(k))) + '</span><span class="abcal-l-only">' + esc(cap(jourLong(k))) + '</span>';
    return '<dl class="abcal-stats">' + stat('Date', date) + stat('Heure', heure(o.start)) +
      (o.prix != null ? stat('Prix', esc(prix(o.prix))) : '') +
      (o.places ? stat('Places', esc(o.places)) : '') + '</dl>';
  }
  function checks(list, cls, extraHtml) {
    list = (list || []).filter(Boolean);
    if (!list.length && !extraHtml) return '';
    return '<ul class="abcal-checks' + (cls ? ' ' + cls : '') + '">' + list.map(function (d) { return '<li>' + esc(d) + '</li>'; }).join('') +
      (extraHtml ? '<li>' + extraHtml + '</li>' : '') + '</ul>';
  }
  function reserveBtn(o, cls, label) {
    if (!o.url) return '';
    var w = whereLabel(o);
    return '<a class="abcal-btn abcal-btn--primary ' + (cls || '') + '" href="' + esc(o.url) + '" target="_blank" rel="noopener">' +
      '<span class="abcal-btn__txt">' + esc(label || 'Réserver ma place') + (w ? '<small>' + esc(w) + '</small>' : '') + '</span>' + icon('arrow') + '</a>';
  }
  /* Sans lien exact : le bouton principal ajoute la soirée au calendrier (jamais « Appeler » : rien ne dit qu'on réserve par téléphone) */
  function calBtn(o, cls, big) {
    var sub = o.session ? o.session + ' · ' + jourCourt(o.key) : 'Apple, Google, Outlook';
    return '<button type="button" class="abcal-btn' + (big ? ' abcal-btn--primary abcal-btn--xl' : '') + (cls ? ' ' + cls : '') + '" data-ics="' + esc(o.id) + '" aria-haspopup="dialog">' +
      (big ? '<span class="abcal-btn__txt">Ajouter au calendrier<small>' + esc(sub) + '</small></span>' + icon('cal')
           : icon('cal') + 'Ajouter à mon calendrier') + '</button>';
  }
  function shareBtn(o, withLabel) {
    return '<button type="button" class="abcal-btn" data-share="' + esc(o.id) + '" aria-label="Partager">' + icon('share') +
      '<span' + (withLabel ? '' : ' class="abcal-hide-s"') + '>Partager</span></button>';
  }
  function callLink(M) {
    var tel = (M.data.boutique || {}).telephone;
    if (!tel) return '';
    return '<a class="abcal-call" href="' + telHref(tel) + '">' + icon('phone') + '<span>Une question ? <b>' + esc(tel) + '</b></span></a>';
  }
  /* Ligne « Inscription… » déjà écrite dans les détails */
  function regDetail(o) { return (o.details || []).filter(function (x) { return /^inscription/i.test(x); })[0] || ''; }
  /* Code d'inscription (ex. Magic Companion) : nom de l'app tiré du texte du bouton ou de la ligne « Inscription dans l'app … » */
  function codeApp(o) {
    var m = /^code\s+(.+?)\s*:/i.exec(o.urlLabel || '');
    if (m) return m[1];
    m = /dans l['\u2019]app\s+(.+?)\s*(?:[:\u00b7,]|$)/i.exec(regDetail(o));
    return m ? m[1] : '';
  }
  /* « Inscription dans l'app Magic Companion · code 3JRW7ER » */
  function codeText(o) {
    if (!o.code) return '';
    var d = regDetail(o).replace(new RegExp('\\s*[:\u00b7,]?\\s*(?:code\\s*:?\\s*)?' + o.code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*\\.?$', 'i'), '').trim();
    if (!d) { var app = codeApp(o); d = app ? 'Inscription dans l\u2019app ' + app : 'Code d\u2019inscription'; }
    return d + ' \u00b7 code ' + o.code;
  }
  /* Où s'inscrire, en texte, tant que le lien exact manque (« Inscription sur Melee », ou le code d'inscription) */
  function regNote(o) {
    if (o.code) return codeText(o);
    if (o.url) return '';
    var d = regDetail(o);
    if (d) return d;
    var w = whereLabel(o);
    return w ? 'Inscription ' + w : '';
  }
  /* Même texte, avec le code mis en valeur (sélection d'un seul geste) */
  function regHtml(o) {
    var r = regNote(o);
    if (!r) return '';
    var h = esc(r);
    if (o.code) {
      var c = esc(o.code), i = h.lastIndexOf(c);
      if (i >= 0) h = h.slice(0, i) + '<b class="abcal-code">' + c + '</b>' + h.slice(i + c.length);
    }
    return h;
  }
  function detailsWithReg(o) {
    var r = regNote(o), d = detailsSansReg(o);
    if (r) d.push(r);
    return d;
  }
  function detailsSansReg(o) {
    var r = regNote(o), rd = (o.code || !o.url) ? regDetail(o) : '';
    return (o.details || []).filter(function (x) { return x !== r && x !== rd; });
  }
  /* Bouton « Copier le code » (le texte clair reste affiché à côté : regHtml) */
  function codeBtn(o, cls, big) {
    if (!o.code) return '';
    var app = codeApp(o);
    return '<button type="button" class="abcal-btn abcal-btn--primary' + (big ? ' abcal-btn--xl' : '') + (cls ? ' ' + cls : '') + '" data-copy="' + esc(o.code) + '"' + (app ? ' data-app="' + esc(app) + '"' : '') + '>' +
      '<span class="abcal-btn__txt"><span data-copy-label>Copier le code</span><small>' + esc(o.code + (app ? ' \u00b7 ' + app : '')) + '</small></span>' + icon('copy') + '</button>';
  }
  function datesOf(g) {
    var ks = g.map(function (o) { return o.key; });
    var sameMonth = ks.every(function (k) { return splitKey(k).m === splitKey(ks[0]).m; });
    var days = ks.map(function (k, i) {
      var s = splitKey(k);
      return JOURS[dow(k)] + ' ' + num(s.d) + (!sameMonth || i === ks.length - 1 ? ' ' + MOIS[s.m - 1] : '');
    });
    var hs = uniq(g.map(function (o) { return heure(o.start); }));
    return cap(joinEt(days)) + (hs.length === 1 ? ' · ' + hs[0] : '');
  }

  /* Rangée compacte, cliquable en entier (semaine, jour choisi, héros « aussi ce soir-là ») */
  function evtRow(o, M, opt) {
    opt = opt || {};
    var big = (o.kind === 'special' && o.head !== false);
    var perk = o.details[0] || o.format || '';
    var pills = [];
    if (big) pills.push('<span class="abcal-pill abcal-pill--big">' + icon('bolt') + 'Gros événement</span>');
    if (o.places) pills.push('<span class="abcal-pill abcal-pill--lim">Places limitées</span>');
    var main = '<a class="abcal-evt__main' + (o.image ? '' : ' abcal-evt__main--noimg') + '" href="#' + anchor(o) + '" data-open="' + esc(o.id) + '" aria-haspopup="dialog">' +
      img(o, 'abcal-evt__thumb', { alt: '', variant: 'mini' }) +
      '<span class="abcal-evt__body">' +
        '<span class="abcal-evt__top"><time class="abcal-evt__time" datetime="' + isoLocal(o.start) + '"><span class="abcal-sr">' + esc(cap(jourLong(o.key))) + ', </span>' + heure(o.start) + '</time>' + tag(o) + '</span>' +
        '<span class="abcal-evt__title">' + esc(nb(o.titre)) + '</span>' +
        (perk ? '<span class="abcal-evt__perk">' + esc(perk) + '</span>' : '') +
        (pills.length ? '<span class="abcal-evt__pills">' + pills.join('') + '</span>' : '') +
      '</span>' +
      (o.prix != null ? coin(o.prix) : '<span></span>') +
      icon('chev', 'abcal-evt__chev') +
    '</a>';
    var cta = !big || opt.cta === false ? '' : o.url ? reserveBtn(o, 'abcal-btn--sm abcal-evt__cta') : o.code ? codeBtn(o, 'abcal-btn--sm abcal-evt__cta') : '';
    return '<li class="abcal-evt' + (big ? ' abcal-evt--big' : '') + '" style="' + styleVars(o.pal) + '">' + main + cta + '</li>';
  }

  /* Rangée « version texte » : tout est écrit, rien n'est caché (SEO, sans JS) */
  function listRow(o) {
    var big = (o.kind === 'special' && o.head !== false);
    var meta = [o.prix != null ? prix(o.prix) : null, o.places ? o.places + ' places' : null, o.format || null].filter(Boolean).join(' · ');
    return '<li class="abcal-lrow' + (big ? ' abcal-lrow--big' : '') + '" style="' + styleVars(o.pal) + '" id="' + anchor(o) + '">' +
      '<time class="abcal-lrow__time" datetime="' + isoLocal(o.start) + '">' + heure(o.start) + '</time>' +
      '<div class="abcal-lrow__body">' +
        '<p class="abcal-lrow__tags">' + tag(o) + (big ? '<span class="abcal-pill abcal-pill--big">' + icon('bolt') + 'Gros événement</span>' : '') + '</p>' +
        '<h4 class="abcal-lrow__title">' + esc(nb(o.titre)) + '</h4>' +
        (meta ? '<p class="abcal-lrow__meta">' + esc(meta) + '</p>' : '') +
        checks(detailsSansReg(o), 'abcal-checks--sm', regHtml(o)) +
        (o.url ? '<a class="abcal-btn abcal-btn--primary abcal-btn--sm" href="' + esc(o.url) + '" target="_blank" rel="noopener">' + esc(o.urlLabel || 'Réserver ma place') + icon('arrow') + '</a>'
          : o.code ? codeBtn(o, 'abcal-btn--sm') : '') +
      '</div>' +
    '</li>';
  }
  function renderList(occs, M, opt) {
    opt = opt || {};
    if (!occs.length) return '<p class="abcal-empty">Rien au calendrier pour ce choix.</p>';
    var groups = [], cur = null;
    occs.forEach(function (o) {
      if (!cur || cur.key !== o.key) { cur = { key: o.key, items: [] }; groups.push(cur); }
      cur.items.push(o);
    });
    return groups.map(function (g) {
      var r = opt.js ? rel(g.key, M.todayKey) : '';
      return '<section class="abcal-lday">' +
        '<h3 class="abcal-lday__head"><time datetime="' + g.key + '">' + esc(cap(jourLong(g.key))) + '</time>' +
        (r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') + '</h3>' +
        '<ul class="abcal-lrows">' + g.items.map(listRow).join('') + '</ul></section>';
    }).join('');
  }
  /* Liste pré-rendue : 5 semaines d'hebdos + tous les événements datés à venir */
  function ssrListOccs(M) {
    var until = addDays(M.todayKey, 35);
    return M.upcoming.filter(function (o) { return o.kind === 'special' || o.key <= until; });
  }

  function renderMonthWord(M) {
    var pm = posterMonth(M), w = cap(MOIS[pm.m - 1]);
    return '<span class="abcal-poster__month" id="abcal-month-word" style="--len:' + w.length + '">' + esc(w) + '</span>';
  }

  function renderHero(M, opt) {
    opt = opt || {};
    var H = heroInfo(M);
    if (H.mode === 'none') {
      return '<div class="abcal-hero__empty"><p>Rien d’annoncé pour l’instant</p><p>Reviens bientôt. Tu peux aussi organiser ta propre soirée.</p></div>';
    }
    var h = H.hero, big = H.mode === 'big', g = H.group, multi = g.length > 1;
    var title = multi ? (h.gLabel || h.titre) : h.titre;
    var id = esc(h.id);
    var r = rel(h.key, M.todayKey);
    var nextImg = H.next && H.next[0].image ? H.next[0] : null;
    var kick = '<p class="abcal-hero__kick"><span class="abcal-badge">' + icon('bolt') + (big ? '<span class="abcal-l-only">Prochain </span>gros événement' : 'Prochaine soirée') + '</span>' +
      (opt.js && !big && r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') +
      (multi ? '<span class="abcal-pill">' + g.length + ' soirées</span>' : '') +
      (h.places ? '<span class="abcal-pill abcal-pill--lim">Places limitées</span>' : '') + '</p>';
    var head = '<div class="abcal-hero__head' + (h.image ? (isWide(h) ? ' abcal-hero__head--wide' : '') : ' abcal-hero__head--noimg') + '"><div class="abcal-hero__intro">' +
        '<p class="abcal-tag abcal-tag--lg"><span class="abcal-dot" aria-hidden="true"></span>' + esc(h.jeu || h.catLabel) + '</p>' +
        '<h2 class="abcal-hero__title" id="abcal-hero-title">' + neonTitle(title, h) + '</h2>' +
      '</div>' +
      (h.image ? '<a class="abcal-hero__thumb" href="#' + anchor(h) + '" data-open="' + id + '" aria-haspopup="dialog">' +
        img(h, '', { eager: true, variant: isWide(h) ? 'thumbWide' : 'thumb', alt: 'Voir l’affiche et la fiche : ' + h.titre }) + '</a>' : '') +
    '</div>';
    var count = opt.js ? '<div class="abcal-count" data-count="' + h.start.toISOString() + '" data-end="' + (h.end ? h.end.toISOString() : '') + '">' +
      '<p class="abcal-count__label">Ça commence dans</p>' +
      '<div class="abcal-count__tiles" role="timer" aria-live="off">' +
      [['d', 'jours'], ['h', 'heures'], ['m', 'min']].map(function (u) {
        return '<span class="abcal-flip" aria-hidden="true"><b data-u="' + u[0] + '">00</b><i>' + u[1] + '</i></span>';
      }).join('') + '<span class="abcal-sr" data-count-sr></span></div></div>' : '';
    /* Lien exact -> « Réserver ma place ». Sinon (JS) -> « Ajouter à mon calendrier » + où s'inscrire en texte + petit lien téléphone. */
    /* Code d'inscription (sans lien) -> « Copier le code » devient l'action principale ; le code reste écrit en clair au-dessus */
    var act = !!(h.url || h.code);
    var primary = h.url ? reserveBtn(h, 'abcal-btn--xl', multi && h.session ? 'Réserver la ' + h.session.toLowerCase() : null)
      : (opt.js ? (h.code ? codeBtn(h, '', true) : calBtn(h, '', true)) : '');
    var sec = opt.js ? '<div class="abcal-hero__sec' + (act ? '' : ' abcal-hero__sec--solo') + '">' +
      (act ? calBtn(h) : '') + shareBtn(h, !act) + '</div>' : '';
    var reg = regHtml(h);
    var regP = reg ? '<p class="abcal-reg' + (h.code ? ' abcal-reg--code' : '') + '">' + reg + '</p>' : '';
    var after = (h.code ? '' : regP) + (h.url ? '' : callLink(M));
    var sessions = multi ? '<div class="abcal-sessions">' + g.map(sessionLink).join('') + '</div>' : '';
    var also = '';
    if (!big && H.night && H.night.length > 1) {
      also = '<div class="abcal-hero__also"><p class="abcal-hud">Aussi ce soir-là</p><ul class="abcal-evts">' +
        H.night.filter(function (o) { return o !== h; }).map(function (o) { return evtRow(o, M); }).join('') + '</ul></div>';
    }
    var notes = [h.format].concat(detailsSansReg(h));
    if (!big && h.mode) notes.push(h.mode);
    var media = '<div class="abcal-hero__media">' +
      (nextImg ? img(nextImg, 'abcal-hero__poster2', { alt: '', focus: false, variant: 'poster' }) : '') +
      img(h, 'abcal-hero__poster', { alt: 'Affiche : ' + h.titre + ', ' + jourLong(h.key) + ' à ' + heure(h.start), focus: false, eager: true, variant: 'poster', dims: true }) + '</div>';
    return '<div class="abcal-hero__grid" style="' + styleVars(h.pal) + '">' +
      (h.image ? media : '') +
      '<div class="abcal-hero__body">' + kick + head + stats(h) + count +
        '<div class="abcal-hero__cta">' + (h.code ? regP : '') + primary + sec + after + '</div>' + sessions + also + checks(notes) +
      '</div>' +
    '</div>';
  }
  function sessionLink(o) {
    return '<a class="abcal-session" href="#' + anchor(o) + '" data-open="' + esc(o.id) + '" aria-haspopup="dialog">' +
      '<b>' + esc(o.session || 'Voir la fiche') + '</b><span>' + esc(cap(jourCourt(o.key))) + ' · ' + heure(o.start) + '</span>' + icon('arrow') + '</a>';
  }

  function renderNext(M, opt) {
    opt = opt || {};
    var g = heroInfo(M).next;
    if (!g || !g.length) return '';
    var f = g[0], multi = g.length > 1;
    var samePrice = g.every(function (o) { return o.prix === f.prix; });
    var samePlaces = g.every(function (o) { return o.places === f.places; });
    var meta = [samePlaces && f.places ? f.places + ' places' + (multi ? ' par soirée' : '') : null, f.format || null].filter(Boolean).join(' · ');
    var r = opt.js ? rel(f.key, M.todayKey) : '';
    var posters = g.filter(function (o) { return o.image; }).slice(0, 2).map(function (o) {
      return '<a class="abcal-next__poster" href="#' + anchor(o) + '" data-open="' + esc(o.id) + '" aria-haspopup="dialog">' +
        img(o, '', { alt: 'Affiche : ' + o.titre + ', ' + jourLong(o.key), focus: false, variant: 'next' }) + '</a>';
    }).join('');
    return '<aside class="abcal-next" id="abcal-next" style="' + styleVars(f.pal) + '" aria-labelledby="abcal-next-title">' +
      '<div class="abcal-next__body">' +
        '<p class="abcal-next__kick"><span class="abcal-hud">Ensuite · ' + esc(f.catLabel) + '</span>' + (r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') +
          (f.places ? '<span class="abcal-pill abcal-pill--lim">Places limitées</span>' : '') + '</p>' +
        '<h2 class="abcal-next__title" id="abcal-next-title"><span class="abcal-neon' + (f.holo ? ' abcal-holo' : '') + '">' + esc(nb(f.gLabel || f.titre)) + '</span></h2>' +
        '<p class="abcal-next__when">' + esc(datesOf(g)) + '</p>' +
        (f.accroche ? '<p class="abcal-next__text">' + esc(f.accroche) + '</p>' : '') +
        '<p class="abcal-next__meta">' + (samePrice && f.prix != null ? coin(f.prix) : '') + '<span>' + esc(meta) + '</span></p>' +
        '<div class="abcal-sessions">' + g.map(sessionLink).join('') + '</div>' +
      '</div>' +
      (posters ? '<div class="abcal-next__posters">' + posters + '</div>' : '') +
    '</aside>';
  }

  /* Cette semaine : liste verticale par jour ; les soirs vides tiennent sur une ligne */
  function renderWeek(M) {
    var days = [];
    for (var i = 0; i < 7; i++) days.push(addDays(M.todayKey, i));
    var html = '', run = [], any = false;
    function flush() {
      if (!run.length) return;
      var a = run[0], b = run[run.length - 1];
      html += '<li class="abcal-dayline"><b>' + esc(cap(jourNum(a)) + (run.length > 1 ? ' → ' + jourNum(b) : '')) + '</b>Pas de tournoi au calendrier</li>';
      run = [];
    }
    days.forEach(function (k) {
      var items = M.byKey[k] || [];
      if (!items.length) {
        if (k === M.todayKey) {
          var nk = days.filter(function (d) { return d > k && (M.byKey[d] || []).length; })[0];
          var line = 'Pas de tournoi ce soir.';
          if (nk) {
            var its = M.byKey[nk], hs = uniq(its.map(function (o) { return heure(o.start); }));
            var when = diffDays(k, nk) === 1 ? 'Demain' : 'Prochaine soirée : ' + jourCourt(nk);
            line += ' ' + when + (hs.length > 1 ? ' dès ' : ', ') + hs[0] + ' : ' + joinEt(uniq(its.map(function (o) { return o.catLabel; }))) + '.';
          }
          html += '<li class="abcal-dayline abcal-dayline--today"><b>' + esc(cap(jourNum(k))) + '</b>' + esc(line) + '</li>';
        } else run.push(k);
        return;
      }
      flush();
      any = true;
      var r = rel(k, M.todayKey);
      html += '<li class="abcal-day"><h3 class="abcal-day__head"><time datetime="' + k + '">' + esc(cap(jourCourt(k))) + '</time>' +
        (r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') + '</h3>' +
        '<ul class="abcal-evts">' + items.map(function (o) { return evtRow(o, M); }).join('') + '</ul></li>';
    });
    flush();
    if (!any) {
      var nxt = M.upcoming[0];
      return '<div class="abcal-week__empty"><p>Pas de soirée au calendrier cette semaine.</p>' +
        (nxt ? '<p><button type="button" class="abcal-btn" data-goto="' + nxt.key + '">Prochaine date : ' + esc(cap(jourCourt(nxt.key))) + icon('arrow') + '</button></p>' : '') + '</div>';
    }
    return '<ol class="abcal-days">' + html + '</ol>';
  }

  /* Hebdos encore actifs : la dernière soirée (actif_au) n'est pas passée */
  function activeHebdos(M) {
    return (M.data.hebdos || []).filter(function (w) {
      var def = M.weeklyDefs[w.id];
      return def && def.firstIn && (!w.actif_au || lastWeekdayOnOrBefore(w.actif_au, def.wd) >= M.todayKey);
    });
  }
  /* Hebdos en cours (pas ceux qui démarrent plus tard) */
  function currentHebdos(M) {
    return activeHebdos(M).filter(function (w) { return !w.actif_du || w.actif_du <= addDays(M.todayKey, 6); });
  }
  var ORDER = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
  function byWeekday(list) {
    var byDay = {};
    list.forEach(function (w) { var j = String(w.jour).toLowerCase(); (byDay[j] = byDay[j] || []).push(w); });
    return ORDER.filter(function (j) { return byDay[j]; }).map(function (j) { return { jour: j, list: byDay[j] }; });
  }
  /* « Lundis et mercredis, 18h. » : tiré des données, jamais figé */
  function routineLine(M) {
    var hs = currentHebdos(M);
    if (!hs.length) return '';
    return cap(joinEt(byWeekday(hs).map(function (d) { return d.jour + 's'; }))) + ', ' + joinEt(uniq(hs.map(function (w) { return w.heure; }))) + '.';
  }

  /* Semaine type : noms des soirées, notes de remplacement, changement de format daté */
  function renderRoutine(M, opt) {
    opt = opt || {};
    var hebdos = activeHebdos(M);
    if (!hebdos.length) return '';
    var b = M.data.boutique || {};
    var days = byWeekday(hebdos).map(function (d) {
      var j = d.jour, list = d.list, shown = [], later = {};
      list.forEach(function (w) {
        var twin = shown.filter(function (s) { return s.categorie === w.categorie; })[0];
        if (twin && w.actif_du && w.actif_du > M.todayKey) (later[twin.id] = later[twin.id] || []).push(w);
        else shown.push(w);
      });
      var hours = uniq(list.map(function (w) { return w.heure; }));
      var items = shown.map(function (w) {
        var def = M.weeklyDefs[w.id], p = palette(w.categorie, M.cats, w.couleur);
        var catLabel = (M.cats[w.categorie] && M.cats[w.categorie].label) || w.jeu;
        var nx = M.upcoming.filter(function (o) { return o.weeklyId === w.id; })[0];
        var bits = String(w.titre).split(' · ');
        var sub = [catLabel + ' · ' + w.heure].concat(bits.slice(1));
        if (w.actif_au) sub.push('jusqu’au ' + jourLong(lastWeekdayOnOrBefore(w.actif_au, def.wd)));
        var notes = [];
        (M.skipped[w.id] || []).forEach(function (s) {
          if (s.key < M.todayKey || diffDays(M.todayKey, s.key) > 70) return;
          notes.push(cap(jourLong(s.key)) + ' : ' + (s.by ? 'remplacée par ' + s.by.titre : 'pas de soirée'));
        });
        (later[w.id] || []).forEach(function (l) {
          var lb = String(l.titre).split(' · ');
          notes.push('Dès le ' + jourLong(firstWeekdayOnOrAfter(l.actif_du, def.wd)) + ' : ' + (lb[1] || l.titre));
        });
        var inner = coin(w.prix) + '<span class="abcal-wk__txt"><span class="abcal-wk__big">' + esc(bits[0]) + '</span>' +
          '<span class="abcal-wk__sub">' + esc(sub.join(' · ')) + '</span></span>' + icon('arrow');
        return '<li class="abcal-wk" style="' + styleVars(p) + '">' +
          (nx ? '<a class="abcal-wk__name" href="#' + anchor(nx) + '" data-open="' + esc(nx.id) + '" aria-haspopup="dialog">' + inner + '</a>'
              : '<p class="abcal-wk__name">' + inner.replace(icon('arrow'), '<span></span>') + '</p>') +
          checks(w.details, 'abcal-checks--sm') +
          notes.map(function (n) { return '<p class="abcal-wk__note">' + icon('swap') + '<span>' + esc(n) + '</span></p>'; }).join('') +
        '</li>';
      }).join('');
      return '<article class="abcal-rday">' +
        '<header class="abcal-rday__head"><h3 class="abcal-rday__name">' + cap(j) + '</h3><p class="abcal-hud">Tous les ' + j + 's · ' + esc(hours.join(' et ')) + '</p></header>' +
        '<ul class="abcal-wks">' + items + '</ul>' +
        (opt.js ? '<button type="button" class="abcal-btn abcal-rday__btn" data-ics-day="' + j + '">' + icon('cal') + 'Ajouter mes ' + j + 's au calendrier</button>' : '') +
      '</article>';
    }).join('');
    var modes = hebdos.filter(function (w) { return !w.inscription_mode; }).length;
    return '<div class="abcal-sechead"><p class="abcal-hud">Chaque semaine</p><h2 class="abcal-h2" id="abcal-routine-title">Tes soirs <em>fixes</em></h2>' +
      '<p class="abcal-sub">' + esc(routineLine(M)) + '</p>' +
      (modes && b.telephone ? '<a class="abcal-call" href="' + telHref(b.telephone) + '">' + icon('phone') + '<span>Une question sur une soirée ? <b>' + esc(b.telephone) + '</b></span></a>' : '') + '</div>' +
      '<div class="abcal-routine__grid" id="abcal-routine">' + days + '</div>';
  }

  /* Résumé des soirs fixes : colonne de droite quand aucun gros événement ne suit le héros (ordinateur) */
  function renderRoutineMini(M) {
    var hs = currentHebdos(M);
    if (!hs.length) return '';
    var days = byWeekday(hs).map(function (d) {
      return '<div class="abcal-mini__day"><h3 class="abcal-mini__name">' + esc(cap(d.jour)) + 's</h3><ul class="abcal-mini__list">' +
        d.list.map(function (w) {
          var p = palette(w.categorie, M.cats, w.couleur);
          var cat = (M.cats[w.categorie] && M.cats[w.categorie].label) || w.jeu || '';
          var nx = M.upcoming.filter(function (o) { return o.weeklyId === w.id; })[0];
          var body = '<span><b>' + esc(String(w.titre).split(' · ')[0]) + '</b><small>' + esc(cat + ' · ' + w.heure) + '</small></span>' + (w.prix != null ? coin(w.prix) : '');
          return '<li style="' + styleVars(p) + '">' + (nx
            ? '<a class="abcal-mini__item" href="#' + anchor(nx) + '" data-open="' + esc(nx.id) + '" aria-haspopup="dialog">' + body + '</a>'
            : '<div class="abcal-mini__item">' + body + '</div>') + '</li>';
        }).join('') + '</ul></div>';
    }).join('');
    return '<aside class="abcal-mini" aria-labelledby="abcal-mini-title"><div><p class="abcal-hud">Chaque semaine</p>' +
      '<h2 class="abcal-mini__title" id="abcal-mini-title">' + esc(routineLine(M).replace(/\.$/, '')) + '</h2></div>' + days +
      '<a class="abcal-btn abcal-mini__more" href="#abcal-chaque-semaine">Tout sur tes soirs fixes' + icon('down') + '</a></aside>';
  }

  /* ---------- JSON-LD schema.org/Event (événements datés à venir seulement) ---------- */
  function address(b) {
    var m = /^(.*?),\s*(.*?),\s*([A-Z]{2})\s+([A-Z]\d[A-Z]\s?\d[A-Z]\d)$/.exec(b.adresse || '');
    return m ? { '@type': 'PostalAddress', streetAddress: m[1], addressLocality: m[2], addressRegion: m[3], postalCode: m[4], addressCountry: 'CA' }
      : { '@type': 'PostalAddress', streetAddress: b.adresse || '', addressCountry: 'CA' };
  }
  function jsonLd(M, abs, pageUrl) {
    abs = abs || function (s) { return s; };
    var b = M.data.boutique || {};
    return M.upcoming.filter(function (o) { return o.kind === 'special'; }).map(function (o) {
      var ev = {
        '@context': 'https://schema.org', '@type': 'Event',
        name: o.titre,
        startDate: isoLocal(o.start),
        eventStatus: 'https://schema.org/EventScheduled',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        /* Lieu externe (champ « location ») : son nom sert d'adresse ; sinon l'adresse de la boutique */
        location: o.lieu ? { '@type': 'Place', name: o.lieu, address: o.lieu } : { '@type': 'Place', name: b.nom || 'AdventureBox', address: address(b), telephone: b.telephone },
        organizer: { '@type': 'Organization', name: b.nom || 'AdventureBox', url: b.site },
        performer: { '@type': 'Organization', name: b.nom || 'AdventureBox' },
        description: [o.jeu, o.format].concat(o.details || []).filter(Boolean).join('. ') + '.'
      };
      if (o.end) ev.endDate = isoLocal(o.end);
      if (o.image) ev.image = [abs(o.image)];
      if (o.places) ev.maximumAttendeeCapacity = o.places;
      if (o.prix != null) {
        ev.offers = { '@type': 'Offer', price: String(o.prix), priceCurrency: 'CAD', availability: 'https://schema.org/InStock' };
        if (o.url) ev.offers.url = o.url;
        else if (pageUrl) ev.offers.url = pageUrl + '#' + anchor(o);
      }
      return ev;
    });
  }

  /* ---------- .ics (RFC 5545 : VTIMEZONE, RRULE, EXDATE, pliage à 75 octets) ---------- */
  function icsEsc(s) { return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }
  function fold(line) {
    var out = [], cur = '', bytes = 0;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      var b = unescape(encodeURIComponent(ch)).length;
      if (bytes + b > (out.length ? 74 : 75)) { out.push(cur); cur = ''; bytes = 0; }
      cur += ch; bytes += b;
    }
    out.push(cur);
    return out.join('\r\n ');
  }
  function icsLocal(date) { var p = parts(date); return '' + p.y + pad(p.m) + pad(p.d) + 'T' + pad(p.h) + pad(p.mi) + '00'; }
  function icsUTC(date) { return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
  var VTZ = ['BEGIN:VTIMEZONE', 'TZID:America/Toronto',
    'BEGIN:DAYLIGHT', 'TZOFFSETFROM:-0500', 'TZOFFSETTO:-0400', 'TZNAME:EDT', 'DTSTART:19700308T020000', 'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU', 'END:DAYLIGHT',
    'BEGIN:STANDARD', 'TZOFFSETFROM:-0400', 'TZOFFSETTO:-0500', 'TZNAME:EST', 'DTSTART:19701101T020000', 'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU', 'END:STANDARD',
    'END:VTIMEZONE'];
  function descOf(o, M, extraLines) {
    var b = M.data.boutique || {};
    var reg = regNote(o);
    return [o.jeu, o.prix != null ? prix(o.prix).replace('\u00a0', ' ') : '', o.places ? o.places + ' places' : '', o.format]
      .filter(Boolean).join(' · ') + (detailsSansReg(o).length ? '\n' + detailsSansReg(o).join('\n') : '') +
      (reg ? '\n' + reg : '') +
      (extraLines && extraLines.length ? '\n' + extraLines.join('\n') : '') +
      (o.url ? '\nInscription : ' + o.url : '') + '\n' + (b.adresse || '') + ' · ' + (b.telephone || '');
  }
  function vevent(o, M, extra) {
    var b = M.data.boutique || {};
    var desc = descOf(o, M);
    var L = ['BEGIN:VEVENT', 'UID:' + (extra && extra.uid || o.id) + '@adventurebox.ca', 'DTSTAMP:' + icsUTC(M.now),
      'DTSTART;TZID=America/Toronto:' + icsLocal(o.start)];
    if (o.end) L.push('DTEND;TZID=America/Toronto:' + icsLocal(o.end));
    if (extra && extra.rrule) L.push(extra.rrule);
    if (extra && extra.exdates && extra.exdates.length) L.push('EXDATE;TZID=America/Toronto:' + extra.exdates.join(','));
    L.push('SUMMARY:' + icsEsc(o.titre + ' · ' + (b.nom || 'AdventureBox')));
    L.push('LOCATION:' + icsEsc(o.lieu || ((b.nom || 'AdventureBox') + ', ' + (b.adresse || ''))));
    L.push('DESCRIPTION:' + icsEsc(desc));
    if (o.url || b.site) L.push('URL:' + (o.url || b.site));
    L.push('END:VEVENT');
    return L;
  }
  function wrapCal(evs) {
    var L = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//AdventureBox//Calendrier//FR', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH'].concat(VTZ);
    evs.forEach(function (e) { L = L.concat(e); });
    L.push('END:VCALENDAR');
    return L.map(fold).join('\r\n') + '\r\n';
  }
  function icsOne(o, M) { return wrapCal([vevent(o, M)]); }
  /* Séries hebdo d'un jour : la série s'arrête à la fin de l'horizon affiché (3 mois) pour ne pas rester à vie dans l'agenda */
  function weeklySeries(jour, M) {
    var out = [];
    Object.keys(M.weeklyDefs).forEach(function (id) {
      var W = M.weeklyDefs[id], w = W.def;
      if (String(w.jour).toLowerCase() !== jour || !W.firstIn) return;
      if (w.actif_au && lastWeekdayOnOrBefore(w.actif_au, W.wd) < M.todayKey) return;
      var until = w.actif_au && w.actif_au < M.horizon ? w.actif_au : M.horizon;
      var last = lastWeekdayOnOrBefore(until, W.wd);
      var all = (M.skipped[id] || []), skipKeys = {};
      all.forEach(function (s) { skipKeys[s.key] = 1; });
      /* Première soirée qui a vraiment lieu (le 30 sept., remplacé par Reality Fracture, n'ouvre pas la série) */
      var first = W.firstIn;
      while (first <= last && skipKeys[first]) first = addDays(first, 7);
      if (first > last) return;
      var o = { id: id, titre: w.titre, jeu: w.jeu, start: zoned(first, W.hm.h, W.hm.mi), end: w.duree_min ? zoned(first, W.hm.h, W.hm.mi + w.duree_min) : null,
        prix: w.prix, places: w.places, format: w.format, details: w.details || [], url: eventUrl(w.inscription_url), urlLabel: w.inscription_label || '', lieu: w.lieu || '' };
      var rr = 'RRULE:FREQ=WEEKLY;BYDAY=' + ICS_DAYS[W.wd] + ';UNTIL=' + icsUTC(zoned(until, 23, 59));
      var skipped = all.filter(function (s) { return s.key > first && s.key <= last; });
      out.push({ o: o, rrule: rr, skipped: skipped, last: last, exdates: skipped.map(function (s) { return icsLocal(zoned(s.key, W.hm.h, W.hm.mi)); }) });
    });
    return out;
  }
  function icsWeekday(jour, M) {
    return wrapCal(weeklySeries(jour, M).map(function (x) {
      return vevent(x.o, M, { uid: x.o.id + '-hebdo', rrule: x.rrule, exdates: x.exdates });
    }));
  }
  /* Google Agenda : lien modèle officiel (action=TEMPLATE), heure murale + fuseau de Sherbrooke */
  function gcal(o, M, recur, extraLines) {
    var b = M.data.boutique || {};
    var s = icsLocal(o.start), e = o.end ? icsLocal(o.end) : s;
    return 'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      '&text=' + encodeURIComponent(o.titre + ' · ' + (b.nom || 'AdventureBox')) +
      '&dates=' + s + '/' + e + '&ctz=' + encodeURIComponent(TZ) +
      '&location=' + encodeURIComponent(o.lieu || ((b.nom || 'AdventureBox') + ', ' + (b.adresse || ''))) +
      '&details=' + encodeURIComponent(descOf(o, M, extraLines)) +
      (recur ? '&recur=' + encodeURIComponent(recur) : '');
  }
  function gcalOne(o, M) { return [{ label: o.titre, href: gcal(o, M) }]; }
  function gcalWeekday(jour, M) {
    return weeklySeries(jour, M).map(function (x) {
      var notes = x.skipped.filter(function (s) { return s.key >= M.todayKey; }).map(function (s) {
        return 'Pas de ' + x.o.titre + ' le ' + jourLong(s.key) + (s.by ? ' (' + s.by.titre + ')' : '') + '.';
      });
      return { label: String(x.o.titre).split(' · ')[0], href: gcal(x.o, M, x.rrule, notes) };
    });
  }
  function slug(s) {
    return String(s || 'evenement').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  G.ABCAL_CORE = {
    TZ: TZ, JOURS: JOURS, JOURS_C: JOURS_C, MOIS: MOIS, MOIS_C: MOIS_C,
    parts: parts, pad: pad, ymd: ymd, keyOf: keyOf, splitKey: splitKey, addDays: addDays, dow: dow, diffDays: diffDays,
    lastOfMonth: lastOfMonth, zoned: zoned, isoLocal: isoLocal, lastWeekdayOnOrBefore: lastWeekdayOnOrBefore, weeklySeries: weeklySeries,
    cap: cap, heure: heure, jourLong: jourLong, jourCourt: jourCourt, jourNum: jourNum, moisLabel: moisLabel, prix: prix, rel: rel,
    plural: plural, joinEt: joinEt, uniq: uniq, esc: esc, telHref: telHref, mapsHref: mapsHref, shortAddr: shortAddr,
    palette: palette, styleVars: styleVars, build: build, groupOf: groupOf, heroInfo: heroInfo, posterMonth: posterMonth,
    icon: icon, tag: tag, coin: coin, img: img, anchor: anchor, stats: stats, checks: checks, reserveBtn: reserveBtn,
    whereLabel: whereLabel, datesOf: datesOf, evtRow: evtRow, listRow: listRow, renderList: renderList, ssrListOccs: ssrListOccs,
    renderMonthWord: renderMonthWord, renderHero: renderHero, renderNext: renderNext, renderWeek: renderWeek, renderRoutine: renderRoutine,
    jsonLd: jsonLd, icsOne: icsOne, icsWeekday: icsWeekday, gcalOne: gcalOne, gcalWeekday: gcalWeekday, slug: slug,
    nb: nb, eventUrl: eventUrl, calBtn: calBtn, shareBtn: shareBtn, callLink: callLink, regNote: regNote,
    detailsWithReg: detailsWithReg, detailsSansReg: detailsSansReg, routineLine: routineLine, renderRoutineMini: renderRoutineMini,
    codeBtn: codeBtn, codeText: codeText, codeApp: codeApp, regHtml: regHtml, groupLabel: groupLabel, isWide: isWide
  };
})(typeof window !== 'undefined' ? window : globalThis);
(function () {
/* AdventureBox · Calendrier · interface (JS vanilla, aucune dépendance) */
function abcalInit() {
  'use strict';
  var C = window.ABCAL_CORE;
  var root = document.getElementById('abcal');
  var dataEl = document.getElementById('ab-events');
  if (!C || !root || !dataEl || root.__abcal) return;
  root.__abcal = true;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  /* Date du jour : ?today=AAAA-MM-JJ fige la date (captures), sinon la vraie date */
  var q = new URLSearchParams(window.location.search);
  var fixed = q.get('today');
  var base = /^\d{4}-\d{2}-\d{2}$/.test(fixed || '') ? C.zoned(fixed, 12, 0) : new Date();
  var t0 = Date.now();
  function now() { return new Date(base.getTime() + (Date.now() - t0)); }

  var M = C.build(data, base);
  var esc = C.esc, icon = C.icon, cap = C.cap;
  var $ = function (s) { return root.querySelector(s); };
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var boutique = data.boutique || {};
  var state = { cat: 'all', month: C.posterMonth(M), selected: null, focusKey: null };

  root.classList.add('abcal--js');

  function visible(o) { return state.cat === 'all' || o.cat === state.cat; }
  function inMonth(k) { var s = C.splitKey(k); return s.y === state.month.y && s.m === state.month.m; }
  /* Début du mois affiché : aujourd'hui s'il tombe moins de 7 jours avant le 1er (ex. 29 sept. -> octobre) */
  function monthFrom() {
    var first = C.ymd(state.month.y, state.month.m, 1), d = C.diffDays(M.todayKey, first);
    return d > 0 && d < 7 ? M.todayKey : first;
  }
  function monthLast() { return C.lastOfMonth(state.month.y, state.month.m); }
  function inShown(k) { return k >= monthFrom() && k <= monthLast(); }
  function monthOccs() { return M.upcoming.filter(function (o) { return inShown(o.key); }); }
  function dayItems(k) { return (M.byKey[k] || []).filter(visible); }

  /* ---------- Mois de l'affiche + bandeau positif « Demain · 18h » ---------- */
  function renderPoster() {
    var slot = $('#abcal-month-word');
    if (slot) slot.outerHTML = C.renderMonthWord(M);
  }
  function renderTicker() {
    var el = $('#abcal-ticker');
    if (!el) return;
    if (!M.upcoming.length) { el.hidden = true; return; }
    el.setAttribute('href', '#abcal-semaine');
    var k = M.upcoming[0].key, list = M.byKey[k];
    var r = C.rel(k, M.todayKey);
    var when = (r === 'Ce soir' || r === 'Demain') ? r : cap(C.jourCourt(k));
    var hs = C.uniq(list.map(function (o) { return C.heure(o.start); }));
    el.innerHTML = '<span class="abcal-live" aria-hidden="true"></span><span class="abcal-ticker__when">' + esc(when) + ' · ' + (hs.length > 1 ? 'dès ' : '') + hs[0] + '</span>' +
      '<span class="abcal-ticker__what"><span class="abcal-l-only">' + list.map(function (o) { return esc(C.nb(o.titre)); }).join(' · ') + '</span>' +
      '<span class="abcal-s-only">' + C.uniq(list.map(function (o) { return o.catLabel; })).map(esc).join(' · ') + '</span></span>' + icon('down');
  }

  /* ---------- Héros, semaine, ensuite, semaine type ---------- */
  function renderHero() {
    $('#abcal-hero').innerHTML = C.renderHero(M, { js: true });
    var h = C.heroInfo(M).hero;
    if (h) root.style.setProperty('--hc1', h.pal.c1);
    /* Affiche paysage (hebdos) : vignette 16:9 au lieu du format affiche */
    var th = root.querySelector('.abcal-hero__thumb img');
    if (th) { var fit = function () { if (th.naturalWidth > th.naturalHeight * 1.2) th.closest('.abcal-hero__head').classList.add('abcal-hero__head--wide'); }; if (th.complete) fit(); else th.addEventListener('load', fit, { once: true }); }
    startCountdown();
  }
  function renderWeek() {
    $('#abcal-semaine').hidden = !M.upcoming.length;
    var last = C.addDays(M.todayKey, 6);
    $('#abcal-week-range').textContent = 'Du ' + C.jourLong(M.todayKey) + ' au ' + C.jourLong(last) + '.';
    $('#abcal-week-list').innerHTML = C.renderWeek(M);
  }
  function renderNext() {
    var slot = $('#abcal-ensuite');
    var html = C.renderNext(M, { js: true }), mini = false;
    if (!html) { html = C.renderRoutineMini(M); mini = !!html; }
    slot.innerHTML = html;
    slot.hidden = !html;
    slot.classList.toggle('abcal-ensuite--mini', mini);
    /* Rien à droite (même pas le résumé) : « Cette semaine » prend toute la largeur */
    root.querySelector('.abcal-duo').classList.toggle('abcal-duo--one', !html);
  }
  function renderRoutine() {
    var sec = $('#abcal-chaque-semaine');
    var html = C.renderRoutine(M, { js: true });
    sec.innerHTML = html;
    sec.hidden = !html;
  }

  /* ---------- Le programme ---------- */
  function monthBounds() {
    var t = C.splitKey(M.todayKey), h = C.splitKey(M.horizon);
    return { min: t.y * 12 + t.m, max: h.y * 12 + h.m };
  }
  function renderChips() {
    var occs = monthOccs(), counts = {};
    occs.forEach(function (o) { counts[o.cat] = (counts[o.cat] || 0) + 1; });
    var cats = Object.keys(M.cats).filter(function (c) { return counts[c]; });
    if (state.cat !== 'all' && !counts[state.cat]) state.cat = 'all';
    var box = $('#abcal-chips');
    box.hidden = cats.length < 2;
    box.innerHTML = '<button type="button" class="abcal-chip abcal-chip--all" data-cat="all" aria-pressed="' + (state.cat === 'all') + '" style="--c1:#a85d0f"><span class="abcal-dot" aria-hidden="true"></span>Tous <small>' + occs.length + '</small></button>' +
      cats.map(function (c) {
        var p = C.palette(c, M.cats);
        return '<button type="button" class="abcal-chip" data-cat="' + esc(c) + '" aria-pressed="' + (state.cat === c) + '" style="' + C.styleVars(p) + '"><span class="abcal-dot" aria-hidden="true"></span>' + esc(M.cats[c].label) + ' <small>' + counts[c] + '</small></button>';
      }).join('');
  }
  function gridStart(y, m) { var first = C.ymd(y, m, 1); return C.addDays(first, -((C.dow(first) + 6) % 7)); }
  function pickDay() {
    var y = state.month.y, m = state.month.m;
    var start = gridStart(y, m), last = C.lastOfMonth(y, m);
    for (var k = start; k <= last; k = C.addDays(k, 1)) {
      if (k >= M.todayKey && dayItems(k).length && (inMonth(k) || C.diffDays(M.todayKey, k) < 7)) return k;
    }
    return inMonth(M.todayKey) ? M.todayKey : C.ymd(y, m, 1);
  }
  function renderProgram() {
    var y = state.month.y, m = state.month.m;
    $('#abcal-programme').hidden = !M.upcoming.length;
    $('#abcal-prog-title').textContent = C.moisLabel(y, m);
    var b = monthBounds(), cur = y * 12 + m;
    root.querySelector('[data-month="-1"]').disabled = cur <= b.min;
    root.querySelector('[data-month="1"]').disabled = cur >= b.max;
    renderChips();
    var occs = monthOccs().filter(visible);
    var nights = C.uniq(occs.map(function (o) { return o.key; })).length;
    var bigs = occs.filter(function (o) { return (o.kind === 'special' && o.head !== false); }).length;
    var mName = C.MOIS[m - 1];
    var note = occs.length ? C.plural(occs.length, 'événement') + ' à venir · ' + C.plural(nights, 'soirée') + '.' : '';
    if (!bigs && occs.length) {
      var dm = (/^[aeiouéè]/.test(mName) ? 'd’' : 'de ') + mName;
      /* Mois en cours : un gros événement a peut-être déjà eu lieu (ex. Pré-Rift les 19 et 20 oct.) */
      var curMonth = inMonth(M.todayKey) || monthFrom() === M.todayKey;
      var pastBig = curMonth && M.all.some(function (o) { return (o.kind === 'special' && o.head !== false) && visible(o) && inMonth(o.key) && M.upcoming.indexOf(o) < 0; });
      note += curMonth ? (pastBig ? ' Plus de gros événement d’ici la fin ' + dm + '.' : ' Pas de gros événement annoncé d’ici la fin ' + dm + ' pour l’instant.') + ' Les soirées de la semaine continuent.'
        : ' Aucun gros événement annoncé en ' + mName + ' pour l’instant. Les soirées de la semaine continuent.';
    }
    if (!occs.length) note = 'Rien au calendrier en ' + mName + ' pour l’instant.';
    $('#abcal-prog-note').textContent = note;
    root.querySelector('.abcal-prog__layout').hidden = !occs.length;
    if (!state.selected || !inShown(state.selected)) state.selected = pickDay();
    state.focusKey = state.selected;
    renderRibbon(); renderGrid(); renderPanel(); renderListView(); renderNextMonth();
  }
  function renderRibbon() {
    var last = monthLast(), html = '';
    for (var k = monthFrom(); k <= last; k = C.addDays(k, 1)) {
      if (k < M.todayKey) continue;
      var items = dayItems(k);
      if (!items.length) continue;
      var big = items.filter(function (o) { return (o.kind === 'special' && o.head !== false); })[0];
      var n = items.length;
      var label = cap(C.jourLong(k)) + ', ' + n + ' événement' + (n > 1 ? 's' : '') + ' : ' + items.map(function (o) { return o.titre; }).join(', ');
      html += '<button type="button" class="abcal-rib__d' + (big ? ' has-big' : '') + (k === M.todayKey ? ' is-today' : '') + '" data-day="' + k + '" aria-pressed="' + (k === state.selected) + '" aria-label="' + esc(label) + '"' + (big ? ' style="' + C.styleVars(big.pal) + '"' : '') + '>' +
        '<small aria-hidden="true">' + C.JOURS_C[C.dow(k)].replace('.', '') + '</small><b aria-hidden="true">' + C.splitKey(k).d + '</b>' +
        '<span class="abcal-rib__dots" aria-hidden="true">' + items.map(function (o) { return '<i style="' + C.styleVars(o.pal) + '"></i>'; }).join('') + '</span></button>';
    }
    $('#abcal-rib').innerHTML = html;
  }
  function renderGrid() {
    var y = state.month.y, m = state.month.m;
    var start = gridStart(y, m), last = C.lastOfMonth(y, m);
    var weeks = Math.ceil((C.diffDays(start, last) + 1) / 7);
    var dows = [['lun.', 'lundi'], ['mar.', 'mardi'], ['mer.', 'mercredi'], ['jeu.', 'jeudi'], ['ven.', 'vendredi'], ['sam.', 'samedi'], ['dim.', 'dimanche']];
    var h = '<table class="abcal-cal" aria-labelledby="abcal-prog-title"><thead><tr>' +
      dows.map(function (d) { return '<th scope="col" abbr="' + d[1] + '">' + d[0] + '</th>'; }).join('') + '</tr></thead><tbody>';
    var k = start;
    for (var w = 0; w < weeks; w++) {
      h += '<tr>';
      for (var d = 0; d < 7; d++) {
        var past = k < M.todayKey;
        var items = past ? [] : dayItems(k);
        var big = items.filter(function (o) { return (o.kind === 'special' && o.head !== false); })[0];
        var cls = ['abcal-daybtn'];
        if (!inMonth(k)) cls.push('is-out');
        if (past) cls.push('is-past');
        if (k === M.todayKey) cls.push('is-today');
        if (big) cls.push('has-big');
        var n = items.length;
        var label = cap(C.jourLong(k)) + (k === M.todayKey ? ', aujourd’hui' : '') + ', ' +
          (past ? 'date passée' : n ? n + ' événement' + (n > 1 ? 's' : '') + ' : ' + items.map(function (o) { return o.titre; }).join(', ') : 'aucun événement');
        h += '<td><button type="button" class="' + cls.join(' ') + '" data-day="' + k + '" aria-pressed="' + (k === state.selected) + '"' +
          ' tabindex="' + (k === state.focusKey ? 0 : -1) + '" aria-label="' + esc(label) + '"' + (big ? ' style="' + C.styleVars(big.pal) + '"' : '') + '>' +
          '<span class="abcal-daybtn__n" aria-hidden="true">' + C.splitKey(k).d + '</span>' +
          (big ? icon('bolt', 'abcal-daybtn__bolt') : '') +
          (n ? '<span class="abcal-daybtn__dots" aria-hidden="true">' + items.map(function (o) { return '<i style="' + C.styleVars(o.pal) + '"></i>'; }).join('') + '</span>' +
            '<span class="abcal-daybtn__pills" aria-hidden="true">' + items.map(function (o) {
              return '<span class="abcal-dpill' + ((o.kind === 'special' && o.head !== false) ? ' abcal-dpill--big' : '') + '" style="' + C.styleVars(o.pal) + '">' + esc(o.catLabel) + '</span>';
            }).join('') + '</span>' : '') +
          '</button></td>';
        k = C.addDays(k, 1);
      }
      h += '</tr>';
    }
    $('#abcal-grid').innerHTML = h + '</tbody></table>';
  }
  function renderPanel() {
    var k = state.selected;
    var items = k >= M.todayKey ? dayItems(k) : [];
    var r = C.rel(k, M.todayKey), n = items.length;
    var html = '<div class="abcal-panel__head"><h3 class="abcal-panel__title">' + esc(cap(C.jourLong(k))) + '</h3>' +
      (r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') +
      '<span class="abcal-hud">' + (n ? C.plural(n, 'événement') : 'Aucun tournoi') + '</span></div>';
    if (n) html += '<ul class="abcal-evts">' + items.map(function (o) { return C.evtRow(o, M); }).join('') + '</ul>';
    else {
      var nxt = M.upcoming.filter(visible).filter(function (o) { return o.key > k; })[0];
      html += '<p class="abcal-empty">' + (k < M.todayKey ? 'Cette date est passée.' : 'Pas de tournoi ce soir-là.') + '</p>' +
        (nxt ? '<p class="abcal-panel__goto"><button type="button" class="abcal-btn" data-goto="' + nxt.key + '">Prochaine date : ' + esc(cap(C.jourCourt(nxt.key))) + icon('arrow') + '</button></p>' : '');
    }
    $('#abcal-panel').innerHTML = html;
  }
  function renderListView() {
    var occs = monthOccs().filter(visible);
    $('#abcal-list').innerHTML = C.renderList(occs, M, { js: true });
    var mn = C.MOIS[state.month.m - 1];
    $('#abcal-all-label').textContent = (monthFrom() < C.ymd(state.month.y, state.month.m, 1)
      ? 'Jusqu’à la fin ' + (/^[aeiouéè]/.test(mn) ? 'd’' : 'de ') + mn : 'Tout ' + mn) + ' en liste (' + occs.length + ')';
  }
  function renderNextMonth() {
    var btn = $('#abcal-nextm'), b = monthBounds(), cur = state.month.y * 12 + state.month.m;
    if (cur >= b.max) { btn.hidden = true; return; }
    var nm = state.month.m === 12 ? 1 : state.month.m + 1;
    btn.hidden = false;
    btn.setAttribute('data-month', '1');
    btn.innerHTML = '<span><small>Mois suivant</small><b>Voir ' + C.MOIS[nm - 1] + '</b></span>' + icon('arrow');
  }
  /* Lecteur d'écran : une phrase courte (le panneau n'est plus relu en entier) */
  var statusEl = document.getElementById('abcal-status'), statusT;
  function announce(msg) {
    if (!statusEl) return;
    statusEl.textContent = '';
    clearTimeout(statusT);
    statusT = setTimeout(function () { statusEl.textContent = msg; }, 60);
  }
  function dayMsg(k) {
    var n = k >= M.todayKey ? dayItems(k).length : 0;
    return cap(C.jourLong(k)) + ', ' + (n ? C.plural(n, 'événement') : 'aucun tournoi');
  }
  function monthMsg() {
    var n = monthOccs().filter(visible).length;
    return C.moisLabel(state.month.y, state.month.m) + ', ' + (n ? C.plural(n, 'événement') : 'rien au calendrier');
  }
  /* Choix d'un jour : mise à jour sur place (pas de réécriture), le focus clavier reste sur le bouton */
  function selectDay(k) {
    state.selected = k; state.focusKey = k;
    root.querySelectorAll('#abcal-rib [data-day], #abcal-grid [data-day]').forEach(function (b) {
      var d = b.getAttribute('data-day');
      b.setAttribute('aria-pressed', String(d === k));
      if (b.classList.contains('abcal-daybtn')) b.tabIndex = d === k ? 0 : -1;
    });
    renderPanel();
  }
  function gotoDay(k) {
    var s = C.splitKey(k);
    state.month = { y: s.y, m: s.m };
    state.selected = k;
    renderProgram();
    var sec = $('#abcal-programme');
    if (sec && sec.scrollIntoView) sec.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Compte à rebours (jours, heures, minutes ; palettes au chargement) ---------- */
  var countTimer = null, lastVals = {}, heroOnScreen = true;
  function countVals() {
    var el = root.querySelector('[data-count]');
    if (!el) return null;
    var diff = Date.parse(el.getAttribute('data-count')) - now().getTime();
    if (diff <= 0) return { done: true, el: el };
    var mins = Math.floor(diff / 6e4);
    return { el: el, d: Math.floor(mins / 1440), h: Math.floor(mins % 1440 / 60), m: mins % 60 };
  }
  function flipOnce(b) {
    b.classList.remove('is-flip'); void b.offsetWidth; b.classList.add('is-flip');
    clearTimeout(b._flipT);
    b._flipT = setTimeout(function () { b.classList.remove('is-flip'); }, 240); /* état final garanti */
  }
  var UNITS = { d: ['jour', 'jours'], h: ['heure', 'heures'] };
  function paint(v, roll) {
    var mods = { d: 100, h: 24, m: 60 };
    ['d', 'h', 'm'].forEach(function (u, i) {
      var b = v.el.querySelector('[data-u="' + u + '"]');
      if (!b) return;
      if (lastVals[u] === v[u]) return;
      lastVals[u] = v[u];
      var lab = b.nextElementSibling;
      if (lab && UNITS[u]) lab.textContent = UNITS[u][v[u] > 1 ? 1 : 0];
      var animate = !reduce.matches && !document.hidden;
      if (!animate) { b.textContent = C.pad(v[u]); return; }
      if (!roll) { b.textContent = C.pad(v[u]); flipOnce(b); return; }
      var steps = 6, n = 0;
      (function step() {
        var val = (v[u] + (steps - n)) % mods[u];
        b.textContent = C.pad(val);
        flipOnce(b);
        if (n++ < steps) setTimeout(step, 75);
      })();
    });
    var sr = v.el.querySelector('[data-count-sr]');
    if (sr) sr.textContent = 'Ça commence dans ' + C.plural(v.d, 'jour') + ', ' + C.plural(v.h, 'heure') + ' et ' + C.plural(v.m, 'minute') + '.';
  }
  function tick(roll) {
    if (document.hidden || !heroOnScreen) return;
    var v = countVals();
    if (!v) return;
    if (v.done) {
      var endAttr = v.el.getAttribute('data-end');
      var over = endAttr && now().getTime() > Date.parse(endAttr);
      v.el.innerHTML = '<p class="abcal-count__live">' + (over ? 'C’est terminé. À la prochaine\u00a0!' : 'C’est commencé. Passe nous voir.') + '</p>';
      v.el.removeAttribute('data-count');
      return;
    }
    paint(v, roll);
  }
  function startCountdown() {
    lastVals = {};
    if (countTimer) clearInterval(countTimer);
    if (!root.querySelector('[data-count]')) return;
    tick(true);
    countTimer = setInterval(function () { tick(false); }, 1000);
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { heroOnScreen = en[0].isIntersecting; if (heroOnScreen) tick(false); }).observe($('#abcal-hero'));
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(false); });

  /* Titre mis en avant (mise_en_avant) : la classe is-lit reste posée ; le style sobre (italique souligné) ne l'anime plus */
  function lightHolo() {
    var els = root.querySelectorAll('.abcal-holo:not(.is-lit)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-lit'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-lit'); io.unobserve(x.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Fiche détail ---------- */
  var sheet = document.getElementById('abcal-sheet');
  var lastFocus = null;
  function passCell(label, value, cls) { return '<div' + (cls ? ' class="' + cls + '"' : '') + '><dt>' + label + '</dt><dd>' + value + '</dd></div>'; }
  function renderSheet(o) {
    var weekly = o.kind === 'weekly', big = (o.kind === 'special' && o.head !== false);
    var r = C.rel(o.key, M.todayKey);
    var group = big ? C.groupOf(M, o) : [o];
    var tags = C.tag(o) + (big ? '<span class="abcal-pill abcal-pill--big">' + icon('bolt') + 'Gros événement</span>' : '') +
      (r ? '<span class="abcal-pill abcal-pill--on">' + r + '</span>' : '') + (o.places ? '<span class="abcal-pill abcal-pill--lim">Places limitées</span>' : '');
    var tabs = group.length > 1 ? '<div class="abcal-tabs" role="group" aria-label="Choisis ta soirée">' + group.map(function (s) {
      return '<button type="button" class="abcal-tab" data-open="' + esc(s.id) + '" aria-current="' + (s === o) + '">' + esc(s.session || cap(C.jourNum(s.key))) + '<span>' + esc(cap(C.jourCourt(s.key))) + ' · ' + C.heure(s.start) + '</span></button>';
    }).join('') + '</div>' : '';
    /* Téléphone : la date prend toute la ligne ; les autres cases vont par deux, la dernière s'étire si elles sont en nombre impair */
    var mid = [['Heure', C.heure(o.start) + (o.end ? '<span class="abcal-sr"> à ' + C.heure(o.end) + '</span>' : '')]];
    if (o.prix != null) mid.push(['Prix', esc(C.prix(o.prix))]);
    if (o.places) mid.push(['Places', esc(o.places)]);
    var pass = '<dl class="abcal-pass">' + passCell('Date', esc(cap(C.jourCourt(o.key))), 'abcal-pass__date') +
      mid.map(function (c, i) { return passCell(c[0], c[1], mid.length % 2 && i === mid.length - 1 ? 'abcal-pass__span' : ''); }).join('') +
      (o.format ? passCell('Format', esc(o.format), 'abcal-pass__wide') : '') + '</dl>';
    var notes = '';
    if (weekly) {
      (M.skipped[o.weeklyId] || []).forEach(function (s) {
        if (s.key >= M.todayKey && C.diffDays(M.todayKey, s.key) <= 70) notes += '<p class="abcal-sheet__info">' + esc(cap(C.jourLong(s.key)) + ' : ' + (s.by ? 'remplacée par ' + s.by.titre : 'pas de soirée') + '.') + '</p>';
      });
    }
    var info = o.mode ? '<p class="abcal-sheet__info">' + esc(o.mode) + '</p>' : ''; /* mode d'inscription rempli par Loïc (ex. « Présente-toi sur place ») */
    var reg = C.regHtml(o);
    /* Lien exact -> « Réserver ma place » ; code d'inscription -> « Copier le code » ; sinon « Ajouter à mon calendrier » en bouton principal */
    var act = !!(o.url || o.code);
    var primary = o.url ? C.reserveBtn(o, 'abcal-btn--xl') : o.code ? C.codeBtn(o, '', true) : C.calBtn(o, '', true);
    var row = '<div class="abcal-sheet__row' + (act ? '' : ' abcal-sheet__row--solo') + '">' + (act ? C.calBtn(o) : '') + C.shareBtn(o, !act) + '</div>';
    var multi = !!(o.groupe && o.session && group.length > 1);
    var title = multi ? (o.gLabel || o.titre) : o.titre;
    var tel = boutique.telephone;
    return '<button type="button" class="abcal-sheet__close" data-close aria-label="Fermer la fiche">' + icon('close') + '</button>' +
      '<div class="abcal-sheet__wrap">' +
      (o.image ? '<div class="abcal-sheet__media"><img class="abcal-sheet__bg" src="' + esc(o.imageMini || o.image) + '" alt="" aria-hidden="true" decoding="async"><img class="abcal-sheet__img" src="' + esc(o.image) + '" alt="' + esc('Affiche : ' + o.titre) + '" decoding="async"></div>' : '') +
      '<div class="abcal-sheet__body">' +
        '<div class="abcal-sheet__tags">' + tags + '</div>' +
        '<h2 class="abcal-sheet__title" id="abcal-sheet-title">' + esc(C.nb(title)) + '</h2>' +
        (multi ? '<p class="abcal-sheet__note">' + esc(o.session + ' · ' + C.jourLong(o.key)) + '</p>' : '') +
        (weekly ? '<p class="abcal-sheet__note">Chaque ' + esc(o.jour) + ' à ' + C.heure(o.start) + '</p>' : '') +
        tabs + pass + '<div class="abcal-perf" aria-hidden="true"></div>' +
        C.checks(C.detailsSansReg(o)) + (reg ? '<p class="abcal-reg' + (o.code ? ' abcal-reg--code' : '') + '">' + reg + '</p>' : '') + notes + info +
        '<p class="abcal-sheet__where"><a class="abcal-sheet__addr" href="' + esc(C.mapsHref(boutique)) + '" target="_blank" rel="noopener">' + icon('pin') + esc(C.shortAddr(boutique)) + '</a>' +
          (tel ? '<a class="abcal-sheet__addr" href="' + C.telHref(tel) + '">' + icon('phone') + esc(tel) + '</a>' : '') + '</p>' +
        '<div class="abcal-sheet__actions">' + primary + row + '</div>' +
      '</div></div>';
  }
  function openSheet(id, trigger) {
    var o = M.byId[id];
    if (!o || !sheet) return false;
    if (!sheet.open) lastFocus = trigger || document.activeElement;
    sheet.innerHTML = renderSheet(o);
    sheet.setAttribute('style', C.styleVars(o.pal));
    if (typeof sheet.showModal === 'function') { if (!sheet.open) sheet.showModal(); } else sheet.setAttribute('open', '');
    sheet.scrollTop = 0;
    var cur = sheet.querySelector('.abcal-tab[aria-current="true"]');
    (cur || sheet.querySelector('.abcal-sheet__close')).focus({ preventScroll: true });
    try { history.replaceState(null, '', window.location.pathname + window.location.search + '#' + C.anchor(o)); } catch (e) {}
    return true;
  }
  function closeSheet() { if (sheet && sheet.open) sheet.close(); }
  if (sheet) {
    sheet.addEventListener('close', function () {
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (e) {}
      if (lastFocus && document.contains(lastFocus) && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
  }

  /* ---------- .ics, partage, toast ---------- */
  var toastEl = document.getElementById('abcal-toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    /* Une fenêtre modale est ouverte : le message doit vivre dedans, sinon il reste derrière */
    var host = (calpick && calpick.open) ? calpick : (sheet && sheet.open) ? sheet : root;
    if (toastEl.parentNode !== host) host.appendChild(toastEl);
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }
  function download(name, text) {
    var blob = new Blob([text], { type: 'text/calendar;charset=utf-8' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url; a.download = name; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 5000);
    toast('Ouvre le fichier .ics pour l’ajouter à ton calendrier.');
  }

  /* Ajouter au calendrier : choix entre le fichier .ics (Apple, Outlook) et Google Agenda.
     Dans Facebook et Instagram (navigateur intégré), le .ics échoue souvent : on le dit et on met Google en premier. */
  var calpick = document.getElementById('abcal-calpick'), calJob = null, calFocus = null;
  var inApp = /FBAN|FBAV|FB_IAB|FBIOS|Instagram/i.test(navigator.userAgent || '');
  function calJobOne(o) {
    return { title: C.nb(o.titre), file: C.slug(o.titre + ' ' + o.key) + '.ics', ics: C.icsOne(o, M), google: C.gcalOne(o, M), note: cap(C.jourLong(o.key)) + ' à ' + C.heure(o.start) + '.' };
  }
  function calJobDay(j) {
    var lastK = C.weeklySeries(j, M).reduce(function (a, x) { return x.last > a ? x.last : a; }, '');
    return { title: 'Tes ' + j + 's', file: 'adventurebox-' + C.slug(j) + 's.ics', ics: C.icsWeekday(j, M), google: C.gcalWeekday(j, M),
      note: lastK ? 'Répété chaque semaine jusqu’au ' + C.jourLong(lastK) + '. Reviens voir le calendrier pour la suite.' : '' };
  }
  function openCal(job, trigger) {
    if (!calpick || typeof calpick.showModal !== 'function') { download(job.file, job.ics); return; }
    calJob = job; calFocus = trigger || document.activeElement;
    var g = job.google || [];
    var icsBtn = '<button type="button" class="abcal-btn' + (inApp ? '' : ' abcal-btn--primary') + '" data-icsgo><span class="abcal-btn__txt">Apple, Outlook et autres<small>fichier .ics</small></span>' + icon('cal') + '</button>';
    var gBtns = g.map(function (x) {
      return '<a class="abcal-btn' + (inApp ? ' abcal-btn--primary' : '') + '" href="' + esc(x.href) + '" target="_blank" rel="noopener" data-gcal>' +
        '<span class="abcal-btn__txt">Google Agenda' + (g.length > 1 ? '<small>' + esc(x.label) + '</small>' : '') + '</span>' + icon('arrow') + '</a>';
    }).join('');
    calpick.innerHTML = '<div class="abcal-calpick__box">' +
      '<button type="button" class="abcal-sheet__close" data-calclose aria-label="Fermer">' + icon('close') + '</button>' +
      '<div><p class="abcal-hud">Ajouter à mon calendrier</p><h2 class="abcal-calpick__title" id="abcal-calpick-title">' + esc(job.title) + '</h2></div>' +
      (inApp ? '<p class="abcal-calpick__warn">Dans Facebook ou Instagram, le fichier .ics bloque souvent. Prends Google Agenda, ou ouvre la page dans Safari ou Chrome.</p>' : '') +
      '<div class="abcal-calpick__opts">' + (inApp ? gBtns + icsBtn : icsBtn + gBtns) + '</div>' +
      (job.note ? '<p class="abcal-calpick__note">' + esc(job.note) + '</p>' : '') +
    '</div>';
    calpick.showModal();
    var first = calpick.querySelector('.abcal-calpick__opts .abcal-btn');
    if (first) first.focus({ preventScroll: true });
  }
  function closeCal() { if (calpick && calpick.open) calpick.close(); }
  if (calpick) {
    calpick.addEventListener('close', function () {
      if (calFocus && document.contains(calFocus) && calFocus.focus) calFocus.focus({ preventScroll: true });
      calFocus = null;
    });
    calpick.addEventListener('click', function (e) { if (e.target === calpick) closeCal(); });
  }
  /* Copier le code d'inscription : presse-papiers moderne, sinon ancienne méthode, sinon le code s'affiche pour copie à la main */
  function copyLegacy(text) {
    var host = (calpick && calpick.open) ? calpick : (sheet && sheet.open) ? sheet : document.body;
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.setAttribute('aria-hidden', 'true');
    ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none';
    host.appendChild(ta);
    var ok = false;
    try { ta.select(); ta.setSelectionRange(0, text.length); ok = document.execCommand('copy'); } catch (e) { ok = false; }
    ta.remove();
    return ok;
  }
  function copyCode(btn) {
    var code = btn.getAttribute('data-copy'), app = btn.getAttribute('data-app');
    function done(ok) {
      if (!ok) { toast('Ton code : ' + code + '. Copie-le à la main.'); return; }
      toast('Code ' + code + ' copié. Colle-le dans ' + (app || 'l’app') + '.');
      var lab = btn.querySelector('[data-copy-label]');
      if (lab) {
        lab.textContent = 'Code copié';
        clearTimeout(btn._copyT);
        btn._copyT = setTimeout(function () { lab.textContent = 'Copier le code'; }, 2600);
      }
    }
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) {
      navigator.clipboard.writeText(code).then(function () { done(true); }, function () { done(copyLegacy(code)); });
    } else done(copyLegacy(code));
  }
  function share(id) {
    var o = M.byId[id];
    if (!o) return;
    var url = window.location.origin + window.location.pathname + '#' + C.anchor(o);
    var text = o.titre + ' · ' + cap(C.jourLong(o.key)) + ' à ' + C.heure(o.start) + ' · AdventureBox, Sherbrooke';
    function fallback() {
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext !== false) {
        navigator.clipboard.writeText(text + ' ' + url).then(function () { toast('Lien copié. Envoie-le à ta gang.'); },
          function () { toast(copyLegacy(text + ' ' + url) ? 'Lien copié. Envoie-le à ta gang.' : 'Copie ce lien : ' + url); });
      } else toast(copyLegacy(text + ' ' + url) ? 'Lien copié. Envoie-le à ta gang.' : 'Copie ce lien : ' + url);
    }
    if (navigator.share) {
      /* Annulé par la personne : rien. Refusé (navigateur intégré, iframe…) : on copie le lien. */
      try { navigator.share({ title: o.titre, text: text, url: url }).catch(function (e) { if (!e || e.name !== 'AbortError') fallback(); }); }
      catch (e) { fallback(); }
      return;
    }
    fallback();
  }

  /* ---------- Événements ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open],[data-ics],[data-ics-day],[data-icsgo],[data-gcal],[data-calclose],[data-share],[data-copy],[data-cat],[data-month],[data-day],[data-goto],[data-close]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-copy')) { copyCode(t); return; }
    if (t.hasAttribute('data-icsgo')) { if (calJob) { var jb = calJob; closeCal(); download(jb.file, jb.ics); } return; }
    if (t.hasAttribute('data-gcal')) { setTimeout(closeCal, 0); return; }
    if (t.hasAttribute('data-calclose')) { closeCal(); return; }
    if (t.hasAttribute('data-open')) { if (openSheet(t.getAttribute('data-open'), sheet && sheet.contains(t) ? null : t)) e.preventDefault(); return; }
    if (t.hasAttribute('data-ics')) { var o = M.byId[t.getAttribute('data-ics')]; if (o) openCal(calJobOne(o), t); return; }
    if (t.hasAttribute('data-ics-day')) { openCal(calJobDay(t.getAttribute('data-ics-day')), t); return; }
    if (t.hasAttribute('data-share')) { share(t.getAttribute('data-share')); return; }
    if (t.hasAttribute('data-close')) { closeSheet(); return; }
    if (t.hasAttribute('data-cat')) {
      var c = t.getAttribute('data-cat');
      state.cat = (c === state.cat && c !== 'all') ? 'all' : c;
      state.selected = null;
      renderProgram();
      announce(monthMsg());
      var again = root.querySelector('[data-cat="' + state.cat + '"]'); if (again) again.focus();
      return;
    }
    if (t.hasAttribute('data-month')) {
      var dm = +t.getAttribute('data-month');
      var total = state.month.y * 12 + state.month.m - 1 + dm;
      state.month = { y: Math.floor(total / 12), m: total % 12 + 1 };
      state.selected = null;
      renderProgram();
      announce(monthMsg());
      if (t.id === 'abcal-nextm') {
        var sec = $('#abcal-programme'); if (sec) sec.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        $('#abcal-prog-title').focus({ preventScroll: true });
      } else if (t.disabled) {
        /* Dernier (ou premier) mois atteint : la flèche se désactive, le focus passe à l'autre */
        var other = root.querySelector('.abcal-arrow:not([disabled])'); if (other) other.focus();
      }
      return;
    }
    if (t.hasAttribute('data-day')) { if (!t.classList.contains('is-past')) { selectDay(t.getAttribute('data-day')); announce(dayMsg(state.selected)); } return; }
    if (t.hasAttribute('data-goto')) { gotoDay(t.getAttribute('data-goto')); return; }
  });
  /* Grille : flèches du clavier (motif « grille » ARIA) */
  root.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('.abcal-daybtn');
    if (!b) return;
    var k = b.getAttribute('data-day');
    var map = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 };
    var nk = null;
    if (map[e.key] != null) nk = C.addDays(k, map[e.key]);
    else if (e.key === 'Home') nk = C.addDays(k, -((C.dow(k) + 6) % 7));
    else if (e.key === 'End') nk = C.addDays(k, 6 - ((C.dow(k) + 6) % 7));
    if (!nk) return;
    var nb = root.querySelector('.abcal-daybtn[data-day="' + nk + '"]');
    if (!nb) return;
    e.preventDefault();
    b.tabIndex = -1; nb.tabIndex = 0; state.focusKey = nk; nb.focus();
  });

  /* ---------- JSON-LD : URL d'image absolues ---------- */
  function refreshJsonLd() {
    var el = document.getElementById('abcal-jsonld');
    if (!el) return;
    var page = (document.querySelector('link[rel="canonical"]') || {}).href || (window.location.origin + window.location.pathname);
    var list = C.jsonLd(M, function (src) { try { return new URL(src, document.baseURI).href; } catch (e) { return src; } }, String(page).split('#')[0]);
    el.textContent = JSON.stringify(list.length === 1 ? list[0] : list);
  }

  /* ---------- Démarrage ---------- */
  renderPoster();
  renderTicker();
  renderHero();
  renderWeek();
  renderNext();
  renderProgram();
  renderRoutine();
  refreshJsonLd();
  lightHolo();
  var all = $('#abcal-all'); if (all) all.open = false;

  var hash = '';
  try { hash = decodeURIComponent((window.location.hash || '').slice(1)); } catch (e) {}
  if (hash.indexOf('abcal-e-') === 0 && M.byId[hash.slice(8)]) openSheet(hash.slice(8));
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abcalInit);
else abcalInit();
/* Éditeur de thème : la section est re-rendue, on relance */
document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('#abcal')) abcalInit(); });
})();
